/* eslint-disable max-len */
import create from 'platform/adapter/message/api/create'
import update from 'platform/adapter/message/api/update'
import change from 'platform/adapter/message/api/change'
import set from 'platform/adapter/message/api/set'
import remove from 'platform/adapter/message/api/delete'
import add from 'platform/adapter/message/api/add'
import activate from 'platform/adapter/message/api/activate'
import cache from 'platform/adapter/message/api/cache'

/**
 * @memberOf Adapter.Message#
 * @typedef Adapter.Message.API
 *
 * Gathers methods used to manage messages.
 *
 * @property {function} set - persist remote payload in G.DATA
 * @property {function} create - remote creation
 * @property {function} update - update remote and local item
 * @property {function} delete - delete remote and local item
 * @property {function} activate - activate a draft message
 *
 * @param {Gaia.Web.Application} app  Platform Web Application
 * @returns {{}}
 */
const api = app => Object.create({}, {
  set: {
    value: set(app),
    iterable: true,
    enumerable: true,
  },
  create: {
    value: create(app),
    iterable: true,
    enumerable: true,
  },
  update: {
    value: update(app),
    iterable: true,
    enumerable: true,
  },
  change: {
    value: change(app),
    iterable: true,
    enumerable: true,
  },
  delete: {
    value: remove(app),
    iterable: true,
    enumerable: true,
  },
  add: {
    value: add(app),
    iterable: true,
    enumerable: true,
  },
  activate: {
    value: activate(app),
    iterable: true,
    enumerable: true,
  },
  cache: {
    value: cache(app),
    iterable: true,
    enumerable: true,
  },
})

export default api
